<template>
  <div class="home">

    <div class="top">
      <div :class="['top-left',{'top-left-shrink':!shrinkFlag}]">
        <!-- <img  class="top-img" src="../assets/avactor.png" alt=""> -->
        <span class="top-name">校餐卫士管理后台</span>
      </div>
      <span class="top-shrink" @click="spreadShrink">
        <i v-if="shrinkFlag" class="iconfont icon-sanhengxian"></i>
        <i v-else class="iconfont icon-sanshuxian"></i>
      </span>
      <span class="top-crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item v-for="(item,index) in crumbData" :key="index">{{item}}</el-breadcrumb-item>
        </el-breadcrumb>
      </span>

      <div class="top-right">
        <!-- 页面全屏缩放 -->
        <!-- <div class="right-full" @click="fullScreen"><span class="iconfont icon-expand"></span></div> -->
        <el-dropdown :hide-on-click="false">
          <span class="el-dropdown-link">
              <!-- <img  class="login-img" src="../assets/avactor.png" alt=""> -->
              <span class="login-text">{{userName}}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item><span @click="changePwdDialog">修改密码</span></el-dropdown-item>
            <el-dropdown-item><span @click="loginOut">退出登陆</span></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <el-dialog class="dialogDiv" :close-on-click-modal="false" v-if="pwdDialogVisible" title="修改密码" :visible.sync="pwdDialogVisible">
        <el-form :model="pwdform" label-position="left" :rules="pwdRules" ref="pwdform">
            <el-form-item label="旧密码: " prop="oldPassword">
                <el-input v-model="pwdform.oldPassword" maxlength="20" placeholder="请输入旧的密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码: " prop="newPassword">
                <el-input v-model="pwdform.newPassword" maxlength="20" placeholder="请输入新的密码, 6-20位数字和字母组合"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码: " prop="checkPassword">
                <el-input v-model="pwdform.checkPassword" maxlength="20" placeholder="请再次输入新的密码, 6-20位数字和字母组合"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="pwdDialogVisible=false" round>关闭</el-button>
            <el-button type="primary" @click="changePwd('pwdform')" round>保存</el-button>
        </div>
    </el-dialog>

    <div :class="['tab',{'tab-collapse':!shrinkFlag}]">
      <tabs ref="menu" :isCollapse="!shrinkFlag" @tabsRoute="tabsRoute" @presentRoute="presentRoute"></tabs>
    </div>

    <div :class="['router-child',{'router-child-shrink':!shrinkFlag}]">
      <div class="nav-level">
      <span v-for="(tag,index) in tags" :key="index" @click="clickTag(index, tag)">
        <el-tag closable @close="handleClose(tag)" :type="tag.type">
          {{tag.name}}
        </el-tag>
      </span>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import tabs from "@/components/tabs";
import * as storage from "@/utils/sessionStorage";
import * as user from '@/api/user'
export default {
  components: { tabs },
  data() {
    return {
        tags: [{name: "菜品列表",routerData: "FoodList",index: "1-1", "superName": "菜品库管理", type: "info"}],
        // tags: [],
        crumbData: ['菜品列表', '菜品库管理'],
        // crumbData: [],
        shrinkFlag: true,
        n: 0,
        userName: '',
        pwdDialogVisible: false,
        pwdform: {
            newPassword: '',
            oldPassword: '',
            checkPassword: ''
        },
        pwdRules: {
            oldPassword: [{ required: true, pattern:/^[a-zA-Z0-9]{6,20}$/ ,message: '密码为6-20位, 请检查后重新输入', trigger: 'blur' }],
            newPassword: [{ required: true, pattern:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/ ,message: '密码为6-20位数字和字母组合, 请检查后重新输入', trigger: 'blur' }],
            checkPassword: [{ required: true, pattern:/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/ ,message: '密码为6-20位数字和字母组合, 请检查后重新输入', trigger: 'blur' }]
        }
    };
  },
  methods: {
    handleClose(tag) {
      console.log(tag);
      let indexBegin;
      this.tags.map((item, index) => {
        if (item === tag) {
          indexBegin = index;
        }
      });
      this.tags.splice(indexBegin, 1);
      storage.setData('routeArr', JSON.stringify(this.tags))
    },

    spreadShrink() {
      this.shrinkFlag = !this.shrinkFlag;
    },

    //tabs组件传入全部选中记录
    tabsRoute(routeArr) {
      this.tags = routeArr;
    },

    //tabs组件传入当前选中路由
    presentRoute(presentRoute) {
      this.crumbData = presentRoute;
    },

    //点击tag
    clickTag(index, tag) {
      // console.log("index值为", index);
      // 页面改变
      this.$router.push({ path: "/" + tag.routerData });
      // 左侧菜单选中改变
      this.$refs['menu'].activeIndex = tag.index;
      // 面包屑改变
      this.crumbData = [tag.superName,tag.name]
    },
    changePwdDialog() {
        this.pwdDialogVisible = true;
    },
    // 修改密码
    changePwd(pwdform) {
        this.$refs.pwdform.validate((valid) => {
            if (valid) {
                user.modifyPwd(this.pwdform).then(r => {
                    if(r.code === 200) {
                        this.$message('密码修改成功, 请重新登录!')
                        this.pwdDialogVisible = false;
                        setTimeout(()=> {
                            this.$router.push({ path: '/login' })
                        }, 500);
                    }
                    this.pwdDialogVisible = false;
                })
            }
        })
    },
    //退出登陆
    loginOut() {
        this.$store.dispatch("logout")//前端登出
        localStorage.removeItem('accessTokenSys')
    },

    //全屏
    fullScreen() {
      this.n++;
      this.n % 2 == 0
        ? this.outFullCreeen(document)
        : this.inFullCreeen(document.documentElement);
    },

    inFullCreeen(element) {
      let el = element;
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    outFullCreeen(element) {
      let el = element;
      let cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    }
  },
    mounted() {
        // 获取右上角用户名
        if(storage.getLocalData('userName')) {
            this.userName = storage.getLocalData('userName')
        } else {
            this.$message.warning('请重新登录') 
            this.$store.dispatch("logout")//前端登出
            this.$router.push({ path: '/login' })
        }
        // 获取上一次记录的面包屑位置并覆盖初始
        if(storage.getData('presentRoute')) {
            this.crumbData =  storage.getData('presentRoute').split(',')
        }
        // 获取最近访问页面的快捷按钮并覆盖初始
        if(storage.getData('routeArr')) {
            this.tags = JSON.parse(storage.getData('routeArr'))
        }
        // 根据面包屑所在位置刷新路由
        if(this.crumbData && this.tags) {
            let crumbName = this.crumbData[this.crumbData.length - 1]
            // 该数组中的页面不会显示在面包屑和快捷访问标签中
            let noTransitionRoutes = ['SubjectAdd', 'SubjectDetail', 'CameraList']
            this.tags.forEach(el => {
                if(el.name === crumbName) {
                    if(noTransitionRoutes.indexOf(this.$route.name) !== -1) return // 三级菜单(未展示在menu里)不随面包屑位置跳转页面
                    this.$router.push({ name: el.routerData })
                }
            })
        }
    }
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}
.lt {
  float: left;
}
.home {
  width: 100%;
  height: 100%;
  .top {
    display: flex;
    width: calc(100% - 20px);
    height: 60px;
    font-size: 30px;
    line-height: 60px;
    text-align: left;
    color: rgb(64, 158, 255);
  }
  .top-name{
    float:left;
    width: 180px;
    text-align: left;
    font-size:20px;
    margin-left:20px;
  }
  .top-img{
    width:30px;
    height:30px;
    float:left;
    margin:15px 0 0 10px;
    border-radius: 6px;
  }

  .tab {
    float: left;
    overflow-y:auto;
    overflow-x:hidden;
    height: calc(100% - 60px);

    //导航未折叠
    .tabs {
      width:200px;
      height: 100%;
      .el-menu {
        height: 100%;
      }
    }
    // 导航折叠
    .tabs-collapse{
      width:55px;
    }
    .tab-collapse{
      width:55px;
    }
  }

  .router-child {
    float: right;
    width: calc(100% - 251px);
    height: calc(100% - 100px);
    padding: 20px;
    overflow: auto;
  }
  .router-child-shrink {
    width: calc(100% - 95px);
  }
  .el-tag {
    cursor: pointer;
  }
}

//顶部样式
.home {
  .top {
    position: relative;
  }

  //左侧标题和logo
  .top-left{
    width:200px;
    background:#1f2d3d;
  }
  .top-left-shrink{
    width:54px;
  }
  .top-name{
    color:#FFFFFF;
  }

  //收缩导航
  .top-shrink {
    margin-left:8px;
    cursor: pointer;
    color: #303133;
    line-height: 60px;
    .more-sanhengxian {
      font-weight: 700;
    }
    .iconfont {
      font-size: 22px;
    }
  }

  //面包屑
  .top-crumbs {
    margin-left: 20px;
    .el-breadcrumb {
      line-height: 60px;
    }
  }

  //右侧内容
  .top-right {
    height: 60px;
    position: absolute;
    right: 0;
    .right-full {
      position: absolute;
      right: 100px;
      cursor: pointer;
      span {
        font-size: 24px;
        color: #909399;
      }
    }
    .login-img {
      position: absolute;
      right: 20px;
      width: 40px;
      height: 40px;
      margin-top: 8px;
      border-radius: 6px;
      cursor: pointer;
    }
    .login-text{
      color:#000000;
    }
  }
}

//横向导航
.nav-level {
  text-align: left;
  margin: -20px 0 20px -20px;
  border-bottom: 1px solid #d8dce5;
  border-top: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  .el-tag {
    height: 26px;
    line-height: 26px;
    margin: 4px 0 4px 4px;
    .el-tag__close:hover {
      background: #409eff;
    }
  }
}
</style>